import React from 'react';
import PortfolioCardMobile from './PortfolioCardMobile';
import styles from '../styles/stylesPortfolioMobile';
import projects from '../data/dataPortfolio';
import usePortfolioLogic from '../hooks/usePortfolioLogic';

function PortfolioMobile() {
  const { carouselRef, activeIndex, totalProjects } = usePortfolioLogic();

  return (
    <section id="portfolio" style={styles.container}>
      <h2 style={styles.title}>Portfólio</h2>

      <div style={styles.carouselWrapper}>
        <div ref={carouselRef} style={styles.carousel}>
          {projects.map((project, index) => (
            <div key={project.id} style={styles.cardWrapper}>
              <PortfolioCardMobile {...project} />
            </div>
          ))}
        </div>
      </div>

      {/* 🔵 Bullets */}
      <div style={styles.bulletsWrapper}>
        {Array.from({ length: totalProjects }).map((_, index) => (
          <div
            key={index}
            style={{
              ...styles.bullet,
              transform: activeIndex === index ? 'scale(1.2)' : 'scale(0.6)',
              opacity: activeIndex === index ? 1 : 0.4,
            }}
          />
        ))}
      </div>
    </section>
  );
}

export default PortfolioMobile;
